import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE005_Request,
  IAPI_PRE005_Response,
} from "../../../type/apiType";

import {
  IAPI_PRE004_Request,
  IAPI_PRE004_Response,
} from "../../../type/apiType";

// 掛金納付期限延長申請参照
// API仕様書_掛金
const httpAPI_PRE005 = async (
  param: IAPI_PRE005_Request
): Promise<IAPI_PRE005_Response> => {
  let res = await http.post(ApiUrl.API_PRE005, {
    ...param,
  });

  return res.data;
};

// 掛金納付期限延長申請更新
// API仕様書_掛金
const httpAPI_PRE004 = async (
  param: IAPI_PRE004_Request
): Promise<IAPI_PRE004_Response> => {
  let res = await http.post(ApiUrl.API_PRE004, {
    ...param,
  });
  return res.data;
};

export { httpAPI_PRE005, httpAPI_PRE004 };
